// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const paymentData = createApi({
  reducerPath: "paymentApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_PAYMENT_API_URL }),
  endpoints: (builder) => ({
    payment: builder.mutation({
      query: (body) => ({
        url: `web_pay`,
        method: "POST",
        body,
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { usePaymentMutation } = paymentData;
